import React from 'react'

import CustomButton from "./CustomButton";

const AIPicker = ({prompt,setPrompt,generatingImg,handleSubmit}) => {
  return (
    <div className='aipicker-container'>
      {/* <textarea
        placeholder='Ask AI...'
        rows={5}
        value={prompt}
        onChange={(e)=>setPrompt(e.target.value)} 
        className='aipicker-textarea'
      /> */}
      <p>
        This feature is currently in development. Please wait for a while before trying again.
      </p>
      <div className='flex flex-wrap gap-3'>
        {generatingImg ? (
          <CustomButton
            type="outlined"
            title="Asking AI..."  
            customStyles="text-xs"
          />
        )
        : (
          <>
            <CustomButton
              type="outlined"
              title="AI Logo"
              handleClick={()=>handleSubmit("logo")}
              customStyles="text-xs"
            />
            <CustomButton
              type="filled"
              title="AI Full"
              handleClick={()=>handleSubmit("full")}
              customStyles="text-xs"
            />
          </>
        )
        }
      </div>
    </div>
  )
}

export default AIPicker